// filebase.ts basic file handling class
// it is the base to create file system for access any online drive
// which need to extent this base class
// it model the FileSystem in javascript
// import { delay, fileExtToContentType } from './appFuncs';

import { EntryMetadata, ExtendedField, FileSystemOptions, FileSystemConfig, PureMetadata, LddLinkFileExt } from './filebase';
import * as fb from './filebase';
import * as largeFileUpload from './filebaseSharepointLargeFileUpload';
import { v4 as uuidv4 } from 'uuid';
import { getErrorMessage } from '../../../../share/utils/errorHandling';

const DocsStorageFolder = "DriveFiles";

export interface SPFileSystemConfig extends FileSystemConfig {
    clientDomain?: string,
    urlOverwrite: string
}
export class BaseEntry extends fb.BaseEntry {
    fileSystem: FileSystem = null;

    static extentedFieldSpec?: Array<string> = ["id", "name", "url", "size", "version"]; // provide what extra fields file system can support
    constructor(name: string, fileSystem: FileSystem) {
        super();
        this.name = name;
        this.fileSystem = fileSystem;
    }

    // request should be use in class functions so it is easy to change instead of direcly use base call
    async httpCall(url: string, method = "GET", postData?: string | Blob | ArrayBuffer, options?: any): Promise<any> {
        //var token = await this.fileSystem.getAccessToken();
        var contentType = "application/json";
        //if (typeof postData === 'object')
        //    contentType = undefined;  // do not send
        var retType = options && options.xhrFields && options.xhrFields.responseType ? options.xhrFields.responseType : '';
        let xhr;
        /*if (method === "PUT") {
            let newUrl = `${this.fileSystem.config.urlOverwrite}&lddurl=${encodeURIComponent(url)}&lddsetting=${JSON.stringify(options)}`;
            newUrl = newUrl.replace("sendToSharepoint", "uploadBlob");
            xhr = await fetch(newUrl, {
                method: "PUT",
                mode: 'cors',
                headers: {
                    "Content-Type": contentType,
                },
                body: postData
            });
        }*/
        if (retType === "blob") {
            let newUrl = `${this.fileSystem.config.urlOverwrite}&lddurl=${encodeURIComponent(url)}`;
            newUrl = newUrl.replace("sendToSharepoint", "getBlob")
            xhr = await fetch(newUrl, {
                method: "GET",
                mode: 'cors',
                headers: {
                    "Content-Type": contentType,
                }
            });
        } else {

            let midPackage = {
                type: contentType,
                rootDrive: this.fileSystem.config.rootDrive,
                url: url,
                method: method,
                postData: postData,
                options: options
            }

            xhr = await fetch(this.fileSystem.config.urlOverwrite, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                //                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                //                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    "Content-Type": contentType,
                },
                //         redirect: 'follow', // manual, *follow, error
                //         referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(midPackage)
            });

        }

        if (xhr.status >= 200 && xhr.status <= 299) {
            switch (retType) {
                case 'blob':
                    return xhr.blob();
                case 'arraybuffer':
                    return xhr.arrayBuffer();
                default:
                    var ret = await xhr.json();
                    if (ret.error > "") {
                        throw ret.error;
                    }
                    return ret;
                /*
                    const contentType = xhr.headers.get("content-type");
                    if (contentType.indexOf("text/xml") !== -1  && options.converters['text xml'] ) {
                        return options.converters['text xml'](await xhr.text());
                    } else if (contentType.indexOf("application/json") !== -1)
                        return xhr.json();
                    else // default return text
                        return xhr.text();*/
            }
        } else {
            throw new Error(`request failed ${xhr.statusText}`);
        }
    }
    /*
     will not overwrite
     both parameters are optional, but you need at least one, otherwise there is nothing to do
    */
    async getGraphUrlByID(): Promise<string> {
        var id = this.id
        if (!(id > "")) {
            var meta = await this.getMetadata();
            id = meta.u_id;
        }
        var url = `${this.fileSystem.config.host}/items/${id}`;
        return url
    }

    async copyTo(newParent?: FolderEntry, newName?: string): Promise<FolderEntry | FileEntry> {
        var newFile: FolderEntry | FileEntry = null;
        try {

            var url = await this.getGraphUrlByID() + `/copy`;
            var myPost = {};
            var newLocation: FolderEntry = null;
            if (newParent) {
                var metaParent = await newParent.getMetadata();
                newLocation = newParent;
                myPost["parentReference"] = {
                    "id": metaParent.u_id
                }
            } else {
                newLocation = await this.getParent();
            }

            if (newName > ""){
                if (this.isLinkFile && newName.indexOf(`.${this.actualExt}`) === -1){
                    newName = `${newName.substring(0, newName.lastIndexOf("."))}.${this.actualExt}`;
                }
                myPost["name"] = newName;
            }
            else newName = this.name;
            await this.httpCall(url, "POST", JSON.stringify(myPost));
            if (this.isFile)
                newFile = await newLocation.getFile(newName);
            else
                newFile = await newLocation.getFolder(newName);
        } catch (e) {
            if (e === "request failed Locked") {
                throw new Error("This document is locked and could not be copied. Please try again later.");
            } else if (e === "request failed Conflict") {
                throw new Error("conflict");
            }
            throw new Error(`Failed to copy file ${this.name}: ${e}`);
        }
        return newFile;
    }

    /*
     will not overwrite
     both parameters are optional, but you need at least one, otherwise there is nothing to do
    */
    async moveTo(newParent: FolderEntry, newName?: string): Promise<FolderEntry | FileEntry> {
        var newFile: FolderEntry | FileEntry = null;
        try {
            var myPost = {};
            var metaParent = await newParent.getMetadata();
            myPost["parentReference"] = {
                "id": metaParent.u_id
            }

            if (newName > "") {
                if (this.isLinkFile && newName.indexOf(`.${this.actualExt}`) === -1){
                    newName = `${newName.substring(0, newName.lastIndexOf("."))}.${this.actualExt}`;
                }
                myPost["name"] = newName;
            } else newName = this.actualName;



            await this.httpCall(this.buildFullPath(), "PATCH", JSON.stringify(myPost));
            if (this.isFile)
                newFile = await newParent.getFile(newName);
            else
                newFile = await newParent.getFolder(newName);
        } catch (e) {
            if (e === "request failed Locked") {
                throw new Error("This document is locked and could not be renamed/moved. Please try again later.");
            } else if (e === "request failed Conflict") {
                throw new Error("conflict");
            }
            throw new Error(`Failed to move file ${this.name}: ${e}`);
        }
        return newFile;
    }


    // need to program the move to recycle bin instead of just delete
    async remove(): Promise<boolean> {
        var ret = true;
        try {
            await this.httpCall(this.buildFullPath(), "DELETE");
        } catch (e) {
            if (e === "request failed Locked") {
                throw new Error("This document is locked and could not be removed. Please try again later.");
            }
            throw new Error(`Failed to remove file ${this.name}: ${e}`);
        }
        return ret;
    }

    async getParent(): Promise<FolderEntry> {
        var root: FolderEntry = this.fileSystem.root;
        var myFolder: FolderEntry = null;
        var path: string = this.fullPath;
        if (!(path === null || path === "")) {
            if (this.fullPath === root.name) myFolder = root;
            else {
                path = path.substring(root.name.length + 1);
                myFolder = await root.getFolder(path);
            }
        }
        return myFolder;
    }

    // just in case standarded fields cannot get it when GetFile
    async getMetadata(selectFields?: [string]): Promise<EntryMetadata> {
        var ret: EntryMetadata = {};
        try {
            var data = await this.httpCall(this.buildFullPath() + "?comp=metadata");
            if (selectFields == null) {
                ret.u_id = data.id;
                ret.created = data.createdDateTime;
                if (data.createdBy && data.createdBy.user)
                    ret.createdBy = data.createdBy.user.email;
                ret.lastModified = data.lastModifiedDateTime;
                if (data.lastModifiedBy && data.lastModifiedBy.user)
                    ret.lastModifiedBy = data.lastModifiedBy.user.email;
            } else {
                for (var i = 0; i < selectFields.length; i++) {
                    switch (selectFields[i].toLowerCase()) {
                        case "created":
                            ret.created = data.createdDateTime;
                            break;
                        case "createdby":
                            if (data.createdBy && data.createdBy.user)
                                ret.createdBy = data.createdBy.user.email;
                            break;
                        case "lastmodified":
                            ret.lastModified = data.lastModifiedDateTime;
                            break;
                        case "id":
                            ret.u_id = data.id;
                            break;
                        case "lastmodifiedby":
                            if (data.lastModifiedBy && data.lastModifiedBy.user)
                                ret.lastModifiedBy = data.lastModifiedBy.user.email;
                            break;
                    }
                }
            }
        } catch (e) {
            throw new Error(`Can not access information for "${this.name}": ${e}`);
        }
        return ret;
    }
    getTags(): Promise<Array<string>> {
        return null;
    }
    addTags(_tags: string | Array<string>): Promise<void> {
        return null;
    }
    // remove all if no tags param
    removeTags(_tags?: string | Array<string>): Promise<void> {
        return null;
    }
    // no name param  get all
    async getPureMeta(): Promise<PureMetadata> {
        var ret: PureMetadata = {};
        var data = await this.httpCall(this.buildFullPath() + "?comp=metadata");
        ret.id = data.id ? data.id : null;
        ret.name = data.name ? data.name : null;
        ret.size = data.size ? data.size : null;
        ret.webUrl = data.webUrl ? data.webUrl : null;
        ret.contentType = data.file && data.file.mimeType ? data.file.mimeType : null;
        ret.contentUrl = data["@microsoft.graph.downloadUrl"] ? data["@microsoft.graph.downloadUrl"] : null;
        // Graph reports the parent as "/drive/root:/client files/Feb 24-2026-1P". The prefix before
        // "root:" varies ("/drive" or "/drives/{id}"), so anchor on the stable "root:" marker.
        ret.parentPath = data.parentReference && data.parentReference.path
            ? data.parentReference.path.split("root:")[1]
            : null;
        return ret;
    }
    async getExtendedFields(names?: string | Array<string>): Promise<ExtendedField | Array<ExtendedField>> {
        var ret: Array<ExtendedField> = [];
        var data = await this.httpCall(this.buildFullPath() + "?comp=metadata");
        if (typeof (names) == "string") {
            let tmp: ExtendedField = {
                "name": names,
                "value": data[names]
            }
            return tmp;
        } else
            for (var i = 0; i < BaseEntry.extentedFieldSpec.length; i++) {
                let field = BaseEntry.extentedFieldSpec[i];
                switch (field) {
                    case "id":
                    case "name":
                    case "size":
                        ret.push({ name: field, value: data[field] } as any);
                        break;
                    case "url":
                        ret.push({ name: field, value: data.webUrl } as any);
                        break;
                }
            }
        return ret;
    }
    updateExtendedFields(_fld: ExtendedField | Array<ExtendedField>): Promise<void> {
        return null;
    }

    async getDownloadUrl(): Promise<string> {
        var myUrl = null;
        try {
            // var path = this.buildFullPath() + "?comp=metadata";
            // path = path;
            var id = await this.getGraphUrlByID();
            var data = await this.httpCall(id + "?comp=metadata");
            myUrl = data.webUrl;
        } catch (e) {
            throw new Error(`Can't retrieve file information: ${getErrorMessage(e)}`);
        }
        return myUrl;
    }
    async getWebUrl():Promise<string>{
        // encode components of matter number and file name, slash should be good but i guess it is not allowed for sharepoint anyway, so it should not happen
        let res = await this.getPureMeta();
        return res.webUrl;
    }
    async getShareableUrl(_who?: string, _expire?: Date): Promise<string> {
        var myUrl = null;
        try {
            var myPost = {
                "type": "edit",
                "scope": "anonymous"
            }
            var data = await this.httpCall(this.buildFullPath() + ":/createLink", "POST", JSON.stringify(myPost));
            myUrl = data.link.webUrl;
        } catch (e) {
            // try to retn webUrl link, user may have access anyway
            return  this.getWebUrl();
          //  throw new Error("Can't create share link " + e);
        }
        // why doing encodeURI? webUrl returned by creatlink should be good as is
        return encodeURI(myUrl);
    }

    buildSubPath(): string {
        var currentPath = "";
        if (this.fullPath > "")
            currentPath = this.fullPath + "/";
        let name = this.actualName;
        /*if (this.isLinkFile){
            name = (this.name).replace(".", `.${LddLinkFileExt}`)
        }*/
        currentPath += name;
        return currentPath;
    }

    buildFullPath(): string {
        var url = `${this.fileSystem.config.host}/root:/${this.buildSubPath()}`;
        return url;
    }
}

export class FileEntry extends BaseEntry implements fb.FileEntry {
    isFile = true;
    isDirectory = false;
    isLinkFile = false;


    private async uploadStorageDoc(content: File | Blob | ArrayBuffer | string){
        const docID: string = uuidv4();
        const newDocName = `${docID}.${this.ext}`;
        let newUrl = `${this.fileSystem.config.urlOverwrite}&name=${encodeURIComponent(newDocName)}&path=${DocsStorageFolder}`;
        newUrl = newUrl.replace("sendToSharepoint", `storageDocUpload`);
        var contentType = (content as any).type;
        if (!(contentType > "")){
            contentType = this.contentType;
        }
        var options: BlobPropertyBag = {}
        if (contentType > "") options.type = contentType;
        
        let myBlob = new Blob([content as File], options);
        const arrayBuffer = await new Response(myBlob).arrayBuffer();
        let storageInfo = await fetch(newUrl,
        {
            headers: {
                'Content-Type': "application/octet-stream",
            },
            method: "POST",
            body: arrayBuffer
        })
        let info = await storageInfo.json();
        if (info.ok){
            const path = info.result.path;
            await this.updateContentLargeFile(path);
        }
        else {
            throw new Error(`error uploading document to storage}`);
        }


    }

    private async getLinkFileURL():Promise<string> {
        //var myUrl:string = "";
        var meta: any = await this.getExtendedFields("@microsoft.graph.downloadUrl");
        var url: string = await this.getGraphUrlByID() + `/content`;
        if (meta.value > "") {
            url = meta.value;
        }
        const f = await fetch(url, {
            method: "GET",
        })
        const txt = await f.text();
        let newUrl = `${this.fileSystem.config.urlOverwrite}&fullPath=${encodeURIComponent(txt)}&nameRequest=${encodeURIComponent(this.name)}`;
        newUrl = newUrl.replace("sendToSharepoint", `storageDocGet`);
        
        return newUrl;
        /*
        let storeInfo = await (await fetch(newUrl)).json();
        if (storeInfo.ok){
            myUrl = storeInfo.url;
        }
        return myUrl;*/
    }
    
    async getShareableUrl(who?: string, expire?: Date): Promise<string> {
        var myUrl = null;
        if (this.isLinkFile){
            try {
                try {
                    let blob = (await this.getContent("blob")) as Blob;
                    const file = new File([blob], this.name, { type: this.contentType });
                    myUrl = URL.createObjectURL(file);
                } catch (e) { }
            }catch(e){
                throw new Error(`error opening document - ${e}`);
            }
        }else {
            myUrl = super.getShareableUrl(who,expire);
        }
        return myUrl;
    }



    private async callContent(url: string, type: 'blob' | 'arrayBuffer' | string | 'xml' = ""): Promise<Blob | ArrayBuffer | string> {
        var myContent = null;
        try {
            var settings: any = {};
            settings['crossDomain'] = true;
            switch (type.toLowerCase()) {
                case "blob":
                    settings.xhrFields = {
                        responseType: 'blob'
                    }
                    /*settings.xhr = function () {// Seems like the only way to get access to the xhr object
                        var xhr = new XMLHttpRequest();
                        xhr.responseType = 'blob';
                        return xhr;
                    };*/
                    if (url.indexOf(this.fileSystem.config.host) !== 0){
                        let res = await fetch(url);
                        myContent = await res.blob();
                    } else {                        
                        myContent = await this.httpCall(url, "GET", null, settings);
                    }
                    break;
                case "arraybuffer":
                    settings.xhrFields = {
                        responseType: 'arraybuffer'
                    }
                    /*settings.xhr = function () {// Seems like the only way to get access to the xhr object
                        var xhr = new XMLHttpRequest();
                        xhr.responseType = 'arraybuffer';
                        return xhr;
                    };*/
                    myContent = await this.httpCall(url, "GET", null, settings);
                    break;

                case "xml":
                    settings.converters = {
                        'text xml': function (data) {
                            /* tomas to fix
                            var tmp = lddCreateXMLDocument();
                            tmp.loadXML(data)*/
                            return data;
                        }
                    };
                    myContent = await this.httpCall(url, "GET", null, settings);
                    break;
                default:
                    var tmp = await this.httpCall(url, "GET", null, settings);
                    myContent = tmp;
            }
        } catch (e) {
            throw new Error(`Can't retrieve file content: ${getErrorMessage(e)}`);
        }
        return myContent;
    }

    async getContent(type: 'blob' | 'arrayBuffer' | string | 'xml', convertToFormat = ""): Promise<Blob | ArrayBuffer | string | XMLDocument> {
        var contentResponse = undefined;
        if (this.isLinkFile){            
            var myUrl = await this.getLinkFileURL();
            let response = await fetch(myUrl);                
            if (response && response.ok) {
                contentResponse = await response.arrayBuffer();
                if (type === 'blob'){
                    contentResponse = new Blob([contentResponse], { type: this.contentType });
                }
            }
        } else {
            var meta: any = await this.getExtendedFields("@microsoft.graph.downloadUrl");
            var url: string = await this.getGraphUrlByID() + `/content`;
            var useDLlink = true;
            if (convertToFormat > "") {
                switch (convertToFormat.toLowerCase()) {
                    case "pdf":
                        if (this.ext !== "pdf") {
                            url += "?format=pdf";
                            useDLlink = false;
                        }
                }
            }
            if (meta.value > "" && useDLlink) {
                url = meta.value;
            }

            contentResponse =  await this.callContent(url, type);
        }
        return contentResponse;
    }

    async downloadFile(): Promise<void> {
        var meta: any = await this.getExtendedFields("@microsoft.graph.downloadUrl");
        var url: string = await this.getGraphUrlByID() + `/content`;
        if (meta.value > "") {
            url = meta.value;
        }

        window.open(url);
    }

    async getHistories?(): Promise<Array<EntryMetadata>> {
        var histories = []
        try {
            var data = await this.httpCall(this.buildFullPath() + ":/versions");
            for (var i = 1; i < data.value.length; i++) {
                var tmp = data.value[i];
                var prev = data.value[i - 1];
                if (prev == null || !(prev.size === tmp.size)) {
                    var entry: EntryMetadata = {}
                    entry.version = tmp.id;
                    entry.lastModified = tmp.lastModifiedDateTime;
                    if (tmp.lastModifiedBy && tmp.lastModifiedBy.user)
                        entry.lastModifiedBy = tmp.lastModifiedBy.user.email;
                    histories.push(entry);
                }
            }
        } catch (e) {
            throw new Error(`Can't retrieve file information: ${getErrorMessage(e)}`);
        }
        return histories;
    }

    async getHistoryContent?(version: string, type?: 'blob' | 'arrayBuffer' | 'xml' | string): Promise<Blob | ArrayBuffer | string> {
        var url = await this.getGraphUrlByID() + `/versions/${version}/content`;
        return await this.callContent(url, type);
    }

    async revertToHistory?(version: string): Promise<boolean> {
        var ret = true;
        try {
            var url = await this.getGraphUrlByID() + `/versions/${version}/restoreversion`;
            await this.httpCall(url);
        } catch (e) {
            ret = false;
        }
        return ret;
    }



    async openDocumentAsPDF(): Promise<void> {
        var url = "";
        if (this.ext === "pdf") {
            url = await this.getDownloadUrl();
        } else {
            var myBlob: Blob = (await this.getContent("Blob", "pdf")) as Blob;
            url = window.URL.createObjectURL(myBlob);
        }
        window.open(url, "_blank");
    }

    async updateContent(content: File | Blob | ArrayBuffer | string): Promise<void> {
        try {
            //var maxSize = 5 * 1024 * 1024;
            if (this.isLinkFile){
                await this.uploadStorageDoc(content)
            }
            else if (true) {//content["byteLength"] >= maxSize || content["size"] > maxSize || content["length"] > maxSize){
                await this.updateContentLargeFile(content);

                /*if (this.fileSystem.config.sharePointDrive > ""){
                    var myPath = this.buildSubPath();
                    url = `${this.fileSystem.config.sharePointDrive}/_api/web/GetFileByServerRelativeUrl('/${encodeURIComponent(myPath)}')/$value`;
                } else {
                    throw "Document size is too big"
                }*/
            } else {
                await this.updateContentSmallFile(content);
            }
            //await this.checkFileIn();
        } catch (e) {
            throw e;
        }
    }

    async checkFileIn(): Promise<void> {
        var initialUrl = await this.getGraphUrlByID();
        var url = initialUrl + `/checkin`;
        try {
            var content = {
                "comment": "Regenerating form RW"
            }
            await this.httpCall(url, "POST", JSON.stringify(content));
        } catch (e) {
           // console.log(`checkin fail ${url}`)
        }
    }


    private async createUploadSession(url): Promise<largeFileUpload.LargeFileUploadSession> {
        var uploadURL = url + "/createUploadSession";
        var content = {
            "@microsoft.graph.conflictBehavior": "replace",
            "fileSystemInfo": { "@odata.type": "microsoft.graph.fileSystemInfo" }
        };
        try {
            var session = await this.httpCall(uploadURL, "POST", JSON.stringify(content), "application/json")
        } catch (e) {
            throw "Error Creating Upload Session" + (e.description > "") ? e.description : e;
        }
        const largeFileUploadSession: largeFileUpload.LargeFileUploadSession = {
            url: session.uploadUrl,
            expiry: new Date(session.expirationDateTime),
        };
        return largeFileUploadSession;
    }

    private async updateContentLargeFile(content: Blob | ArrayBuffer | string): Promise<void> {
        var initialUrl = await this.getGraphUrlByID();
        var contentType = this.contentType;
        var options: BlobPropertyBag = {}
        if (contentType > "") options.type = contentType;
        var myBlob: Blob = new Blob([content], options);
        var largeFileUploadSession = await this.createUploadSession(initialUrl);
        await largeFileUpload.uploadLargeFile(largeFileUploadSession, myBlob, this.name);
    }

    private async updateContentSmallFile(content: Blob | ArrayBuffer | string): Promise<void> {
        var initialUrl = await this.getGraphUrlByID();
        var url = initialUrl + `/content`;
        var settings: any = {};
        if (content && content["type"]) { // Blob
            settings.headers = {
                "Content-Type": content["type"]
            }
            settings.processData = false;
        }
        else if (content["byteLength"] > 0) {   // ArrayBuffer
            settings.processData = false;
            settings.ContentLength = content["byteLength"];
        } else { // string
            settings.headers = {
                "Content-Type": "text/plain"
            }
        }
        await this.httpCall(url, "PUT", content, settings);
    }

    async openDocument(readMode = true, desktopWord = false): Promise<void> {
        let url = "";
        if (desktopWord) {
            // Desktop Word (opened via the ms-word: protocol) must be handed the file's REAL
            // SharePoint URL. We can't reuse the app's folder path (it's virtualized) or
            // config.host (a token only our backend understands), because Word fetches the file
            // itself with no backend in between. So read the file's own metadata and reassemble
            // its true address from three real pieces the metadata reports.
            //
            // Worked example (one file):
            //   meta.webUrl     = https://ldduat.sharepoint.com/sites/f1000321/_layouts/15/Doc.aspx?sourcedoc=...
            //   meta.parentPath = /client files/Feb 24-2026-1P
            //   meta.name       = [Feb 24-2026-1P] Doug Doc Test.docx
            //   => ms-word:ofe|u|https://ldduat.sharepoint.com/sites/f1000321/Shared%20Documents/client%20files/Feb%2024-2026-1P/%5BFeb%2024-2026-1P%5D%20Doug%20Doc%20Test.docx
            const meta = await this.getPureMeta();

            // Site root: everything in webUrl before SharePoint's "/_layouts/..." viewer suffix.
            const siteRoot = meta.webUrl.split("/_layouts")[0];

            // The default document library's real URL name is "Shared Documents"
            // (its display name in the UI is "Documents").
            const libraryName = "Shared Documents";

            // Build the path inside the site, then URL-encode each segment (spaces, brackets, ...).
            // Only the in-site path is encoded; siteRoot is already a valid URL.
            const relativePath = `${libraryName}${meta.parentPath}/${meta.name}`
                .split("/")
                .map(encodeURIComponent)
                .join("/");

            url = `ms-word:ofe|u|${siteRoot}/${relativePath}`;
        } else {
            url = await this.getDownloadUrl();
            if (readMode) {
                url = url.replace("&action=default", "&action=view");
            }

        }
        window.open(url);
    }
}


function fillNewEntryProporties(newEntry: FileEntry | FolderEntry, currentPath: string, data: any): FileEntry | FolderEntry {
    newEntry.fullPath = currentPath;
    newEntry.id = data.id;
    if (data.lastModifiedDateTime) newEntry.modifiedDate = data.lastModifiedDateTime;
    if (data.createdDateTime) newEntry.createdDate = data.createdDateTime;
    if (data.size) newEntry.size = data.size;
    if (data.createdBy && data.createdBy.user) newEntry.createdBy = data.createdBy.user.displayName;
    let ext = newEntry.ext;
    if (newEntry.isFile && ext.indexOf(LddLinkFileExt) === 0){
        newEntry.name = (newEntry.name).replace(`.${LddLinkFileExt}`, ".");
        newEntry.isLinkFile = true;
    }
    return newEntry;
}

export class FolderEntry extends BaseEntry implements fb.FolderEntry {
    isFile = false;
    isDirectory = true;
    isLinkFile = false;

    // may support wild card filespec 
    async getContentList(_filespec?: string): Promise<Array<FileEntry | FolderEntry>> {
        var myContent: Array<FileEntry | FolderEntry> = [];
        var currentPath = this.buildSubPath();
        var url = `${this.fileSystem.config.host}/root:`;
        if (this.fileSystem.config.fileUrl > "")
            url += `('${this.fileSystem.config.fileUrl}${currentPath}')`;
        else
            url += "/" + currentPath;

        url += ":/children";

        try {
            var data = await this.httpCall(url);
            var folders = data.value
            for (var i = 0; i < folders.length; i++) {
                var theName = folders[i].name;
                var newEntry: any = null;
                if (folders[i].folder) {
                    newEntry = new FolderEntry(theName, this.fileSystem);
                } else {
                    newEntry = new FileEntry(theName, this.fileSystem);
                }
                if (newEntry) {
                    newEntry = fillNewEntryProporties(newEntry, currentPath, folders[i] as any);
                    myContent.push(newEntry);
                }
            }
            /*var files = data['d'].Files.results
            for (var i = 0; i < files.length; i++) {
                var newFile: FileEntry = new FileEntry(folders[i].Name, this.fileSystem);
                newFile.fullPath = currentPath;
                myContent.push(newFile);
            }*/
        } catch (e) {
            throw new Error(`Error getting folder content: ${getErrorMessage(e)}`);
        }

        return myContent;
    }


    // name can be under sub directory like  '456/uploaded/driverlic.png'
    // there is not no reason not support absulate path as well like '/client files/2019/02/M43458/inital letter.docx' 
    // but logiclly not good idea, it make the code not easy to read
    // create if do not exist when pass {create:true} option, it should be able to create sub directory as well
    async getFolder(name: string, options?: FileSystemOptions): Promise<FolderEntry> {
        if (!(name > "")) throw new Error("Folder name not specified");
        var myFolder: FolderEntry = null;
        //var url = `${this.fileSystem.config.rootUrl}('${this.fileSystem.config.fileUrl}${this.buildCurrentPath()}/${name}')`;
        var url = `${this.buildFullPath()}/${name}`;
        var subFolderPath = name.lastIndexOf('/') === -1 ? "" : name.substring(0, name.lastIndexOf('/'));
        try {
            var data = await this.httpCall(url);
            myFolder = new FolderEntry(data.name, this.fileSystem);
            var currentPath = this.buildSubPath();
            if (subFolderPath > "") currentPath += "/" + subFolderPath;
            myFolder = fillNewEntryProporties(myFolder, currentPath, data as any) as FolderEntry;
        } catch (e) {
            if (options && options.create) {
                try {
                    var actualName = name;
                    var fullPath = `${this.buildFullPath()}`;
                    url = fullPath;
                    if (subFolderPath) {
                        await this.fileSystem.root.getFolder(subFolderPath, options);
                        // why need delay   await delay(5000)
                        actualName = actualName.substring(actualName.lastIndexOf('/') + 1);
                        url += `/${subFolderPath}`;
                    }
                    url += `:/children`;
                    var myPost = {
                        "name": actualName,
                        "folder": {}
                    }
                    try {
                        try {
                            await this.httpCall(url, "POST", JSON.stringify(myPost));
                        } catch (e) {
                            var myPost2 = {
                                "name": this.name,
                                "folder": {}
                            }
                            var sub = fullPath.substring(0, fullPath.lastIndexOf("/"));
                            var subUrl = sub + `:/children`;
                            if (sub.lastIndexOf(":") === (sub.length - 1)) { // if at root
                                subUrl = sub.substring(0, sub.length - 1) + "/children";
                            }
                            await this.httpCall(subUrl, "POST", JSON.stringify(myPost2));
                            //    await delay(5000)
                            await this.httpCall(url, "POST", JSON.stringify(myPost));
                        }
                        //await fsoMakeTheCall(url, "POST", `{"name": "${actualName}","folder": { }}`);
                        // await delay(5000);
                        myFolder = await this.fileSystem.root.getFolder(name);
                    } catch (e) {

                    }
                } catch (e) {
                    throw new Error(`Can't create folder '${name}': ${e}`);
                }
            } else {
                throw new Error(`Can't retrieve folder '${name}': ${e}`);
            }
        }

        return myFolder;
    }

    async getFileByID(id: string): Promise<FileEntry> {
        if (!(id > "")) throw new Error("File id not specified");
        var myFile: FileEntry = null;
        try {
            var url = `${this.fileSystem.config.host}/items/${id}`;
            var data = await this.httpCall(url);
            var currentPath = this.buildSubPath();
            myFile = new FileEntry(data.name, this.fileSystem);
            var fileLoc = data.parentReference.path;
            var newPath = fileLoc.substring(fileLoc.indexOf(currentPath) + currentPath.length);
            myFile.fullPath = currentPath + newPath;
        } catch (e) {
            throw new Error(`Can't retrieve file '${id}': ${e}`);
        }
        return myFile;
    }
    async getFile(name: string, options?: FileSystemOptions, fileContent?: | Blob | ArrayBuffer): Promise<FileEntry> {
        if (!(name > "")) throw new Error("File name not specified");
        let fileExtension = name.substring(name.indexOf(".")+1);
        let myFile: FileEntry = null;
        let url = `${this.buildFullPath()}/${name}`;
        let subFolderPath = name.lastIndexOf('/') === -1 ? "" : name.substring(0, name.lastIndexOf('/'));
        let currentPath = this.buildSubPath();
        if (subFolderPath > "") currentPath += "/" + subFolderPath;
        try {
            let data = undefined;
            try {
                data = await this.httpCall(url); // check proper name, if not exist check link name if possible
            } catch(e) {
                let actualName = name;
                if (subFolderPath > "") {
                    actualName = actualName.substring(actualName.lastIndexOf('/') + 1);
                }
                let asLinkFile=shouldBeLinkFile(actualName);
                if (asLinkFile){
                    actualName = createLinkFileName(actualName, fileExtension);
                    url = `${this.buildFullPath()}/${actualName}`; 
                    data = await this.httpCall(url);
                } else { // not link file
                    throw e;
                }
            }
            
            myFile = new FileEntry(data.name, this.fileSystem);
            myFile = fillNewEntryProporties(myFile, currentPath, data as any) as FileEntry;
            if (options && options.overwrite && fileContent) {
                try {
                    await myFile.updateContent(fileContent);
                } catch (e) {
                    throw new Error("ldd_found_butFailedUpdate" + e);
                }
            }
        } catch (e) {
            if (e.indexOf("ldd_found_butFailedUpdate") === 0) {
                throw e.replace("ldd_found_butFailedUpdate", "");
            }
            else if (options && options.create && fileContent) {
                try {
                    let pFolder: FolderEntry = null;
                    let actualName = name;
                    if (subFolderPath > "") {
                        pFolder = await this.getFolder(subFolderPath, { create: true });
                        actualName = actualName.substring(actualName.lastIndexOf('/') + 1);
                    }
                    let asLinkFile=shouldBeLinkFile(actualName);
                    if (asLinkFile){
                        actualName = createLinkFileName(actualName, fileExtension);
                    }
                    let url2 = (pFolder === null) ? await this.getGraphUrlByID() + `/children`: await pFolder.getGraphUrlByID() + `/children`;
                    let myPost = {
                        "name": actualName,
                        "file": {}
                    };
                    let data2 = await this.httpCall(url2, "POST", JSON.stringify(myPost));
                    myFile = new FileEntry(data2.name, this.fileSystem);
                    myFile = fillNewEntryProporties(myFile, currentPath, data2 as any) as FileEntry;
                    try {
                        await myFile.updateContent(fileContent);
                    } catch (e) {
                        try {
                            await myFile.remove();
                        } catch (e) {
                        }
                        throw new Error("can't update file" + e);
                    }
                } catch (e) {
                    throw new Error(`Can't create file '${name}': ${e}`);
                }
            } else {
                throw new Error(`Can't retrieve file '${name}': ${e}`);
            }
        }
        return myFile;
    }
}

function createLinkFileName(actualName:string, fileExtension:string):string {
    actualName = actualName.substring(0, actualName.indexOf(".")) + "." + LddLinkFileExt + fileExtension;
    return actualName
}

function shouldBeLinkFile(name:string):boolean {
    let ext = name.substring(name.lastIndexOf(".")+1); 
    let blobStorageExt = ["pdf", "jpg", "png", "gif", "svg", "jpeg", "apng", "avif", "webp", "jfif", "pjpeg", "pjp"];
    let ret = false;
    if (blobStorageExt.includes(ext)){
        ret = true;
    }   
    return ret;
}
export class FileSystem extends fb.FileSystem {
    config: SPFileSystemConfig = null;
    root: FolderEntry = null;
    constructor(config: SPFileSystemConfig) {
        super(config); // doesn't seem to set in this env
        this.config = config;
        //console.log('file system '+ this.config)
        this.root = new FolderEntry(config.rootDrive, this);
    }

    async getAccessToken(): Promise<string> {
        return "ldd_fake_drive_token"
    }
}